const companyInfo = {
    name: '南京新锐鹏环保科技有限公司',
    introduction: ['南京新锐鹏环保科技有限公司位于南京市江宁经济技术开发区，是一家专注于环保在线监测仪器研发、生产、销售、安装调试、系统集成配套的高新技术企业，，通过ISO多项质量体系认证，自主研发多项软件产品及专利。公司占地面积约 5000 平方，拥有研发、生产、技术支持、管理人员近百人，经过多年的技术积累及行业标准优化改革，已形成较为完善的技术支持和售后服务体系，在全国设有多个服务网点和办事处，设有可供应全国的一级备件总库，24小时免费客服热线， 48小以内给出解决方案。公司以优良的品质和一流的服务在行业中建立了良好的口碑,赢得了广泛的赞誉。', '公司目前的主营业务包括：智慧环境监测与治理，工业过程分析与运维，安全监测，水利水务，水生态综合治理等。为各行业用户提供领先的技术应用服务和绿色智慧城市解决方案。公司产品广泛应用于环保、印刷、农业、冶金、石化、化工、能源、水利、制药、酿造、科学研究等众多行业。', '公司始终以“振兴环境监测仪器和高科技治理技术”为使命，通过技术、产品、业务及管理模式的不断创新，持续提升企业核心竞争力，为公司打造成为中国一流的环境监测治理公司、世界一流的分析仪器品牌而努力。'],
    address: '江苏省南京市溧水经济开发区曹吕路9号',
    tel: '025-56603180'
}

export default companyInfo